import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "disbursement-history" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_4 = {
  key: 2,
  class: "history-list"
}
const _hoisted_5 = { class: "entry-header" }
const _hoisted_6 = { class: "entry-meta" }
const _hoisted_7 = { class: "cert-info" }
const _hoisted_8 = { class: "timestamp" }
const _hoisted_9 = { class: "user" }
const _hoisted_10 = {
  key: 0,
  class: "menu-container"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "entry-body" }
const _hoisted_15 = { class: "comment-text" }

import { ref, onMounted, onUnmounted, computed } from 'vue';
import { CertificationVM } from '@/types/certifications';
import { DisbursementHistory } from '@/types/disbursements';
import { $api } from '@/services/api1';
import PermissionsWrapper from "@/components/wrappers/PermissionsWrapper.vue";
import { Permissions, PermissionLevels } from "@/models/permissions";
import functions from '@/use/functions';


export default /*@__PURE__*/_defineComponent({
  __name: 'TabDisbursementHistory',
  props: {
    certification: {}
  },
  emits: ["editPostDisbursement"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isLoading = ref(false);
const historyEntries = ref<DisbursementHistory[]>([]);
const activeMenuId = ref<number | null>(null);

const latestPostDisbChanges = computed(() => {
  const latest = new Map<number, number>(); // disbursementId -> postDisbChangeAmountLedgerId
  const postDisbEntries = historyEntries.value
	.filter(e => e.postDisbursementChangeAmountLedgerId != null);
  
  for (const entry of postDisbEntries) {
	const disbId = entry.disbursementId;
	const postDisbId = entry.postDisbursementChangeAmountLedgerId;
	
	const currentLatest = latest.get(disbId);
    if (!currentLatest || postDisbId > currentLatest) {
      latest.set(disbId, postDisbId);
    }
  }
  
  return latest;
});

onMounted(async () => {
  await loadHistory();
  document.addEventListener('click', closeAllMenus);
});

onUnmounted(() => {
  document.removeEventListener('click', closeAllMenus);
});

async function loadHistory() {
  isLoading.value = true;
  try {
    const response = await $api.certifications.getDisbursementHistory({
      certificationId: props.certification.form.id,
      appId: props.certification.appId,
      loanId: props.certification.loanId,
    });
    
    if (response.success && response.results) {
      historyEntries.value = response.results.entries || [];	  
    } else {  
      functions.openModal({
      title: 'Error',
      description: 'Failed to load disbursement history.',
      });
    }
  } catch (error) {	
    functions.openModal({
      title: 'Error',
      description: 'An error occurred while loading history.',
    });
  } finally {
	  isLoading.value = false;
  }
}

function isLatestPostDisbChange(entry: DisbursementHistory): boolean {
  if (!entry.postDisbursementChangeAmountLedgerId) return false;
  
  const latestId = latestPostDisbChanges.value.get(entry.disbursementId);
  return latestId === entry.postDisbursementChangeAmountLedgerId;
}

function shouldShowMenu(entry: DisbursementHistory): boolean {  
  return isLatestPostDisbChange(entry);
}

function toggleMenu(entryId: number) {
  activeMenuId.value = activeMenuId.value === entryId ? null : entryId;
}

function closeAllMenus() {
  activeMenuId.value = null;
}

function handleEditPostDisbursement(entry: DisbursementHistory) {
  if (!entry.postDisbursementChangeAmountLedgerId) return;
    
  emit('editPostDisbursement', {
	disbursementId: entry.disbursementId,
	postDisbursementChangeAmountLedgerId: entry.postDisbursementChangeAmountLedgerId,
  });
  
  activeMenuId.value = null;
}

async function handleGenerateModFile(entry: DisbursementHistory) {
  if (!entry.postDisbursementChangeAmountLedgerId) return;
  
  activeMenuId.value = null;  
  try {
	const response = await $api.certifications.generateModificationFile(entry.certificationId);
	
	if (response.success) {
	  functions.openModal({
		title: 'Success',
		description: 'Modification file has been generated successfully.',
	  });
	} else {
	  functions.openModal({
		title: 'Error',
		description: 'Failed to generate modification file.',
	  });
	}
  } catch (error) {	
    functions.openModal({
      title: 'Error',
      description: 'An error occurred while generating the modification file.',
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "spinner" }, null, -1),
          _createElementVNode("span", null, "Loading history...", -1)
        ]))]))
      : (historyEntries.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("p", null, "No disbursement history available.", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyEntries.value, (entry) => {
              return (_openBlock(), _createElementBlock("div", {
                key: entry.id,
                class: _normalizeClass(["history-entry", { 'is-latest': isLatestPostDisbChange(entry) }])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(entry.sequencesText), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "separator" }, "|", -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(entry.createdAtFormatted), 1),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "separator" }, "|", -1)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(entry.userDisplayName), 1)
                  ]),
                  _createVNode(PermissionsWrapper, {
                    disabled: !__props.certification.isEditable,
                    showDisabledIfNotVisible: true,
                    permissionIds: [_unref(Permissions).CertAndDisburse],
                    permissionLevel: _unref(PermissionLevels).Update
                  }, {
                    default: _withCtx(() => [
                      (shouldShowMenu(entry))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["kebab-btn", { active: activeMenuId.value === entry.id }]),
                              onClick: _withModifiers(($event: any) => (toggleMenu(entry.id)), ["stop"])
                            }, " ⋮ ", 10, _hoisted_11),
                            (activeMenuId.value === entry.id)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "dropdown-menu",
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                }, [
                                  _createElementVNode("button", {
                                    class: "menu-item",
                                    onClick: ($event: any) => (handleEditPostDisbursement(entry))
                                  }, " Edit ", 8, _hoisted_12),
                                  (props.certification.canGenerateModificationFile)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "menu-item",
                                        onClick: ($event: any) => (handleGenerateModFile(entry))
                                      }, " Generate Modification File ", 8, _hoisted_13))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "permissionIds", "permissionLevel"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(entry.comment), 1)
                ])
              ], 2))
            }), 128))
          ]))
  ]))
}
}

})